import { render } from "./FilterIpirangaUsers.vue?vue&type=template&id=8b9c3906&scoped=true&ts=true"
import script from "./FilterIpirangaUsers.vue?vue&type=script&lang=ts"
export * from "./FilterIpirangaUsers.vue?vue&type=script&lang=ts"

import "./FilterIpirangaUsers.vue?vue&type=style&index=0&id=8b9c3906&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9c3906"]])

export default __exports__